import createCtx from 'coreUtils/createCtx';

/**
 * This context aimed to be used when we should detect if anything inside of it
 * is in the user's viewport
 */
export const [useVisibilityContext, VisibilityContextProvider] = createCtx<{
	handleVisibilityChange: (data: any) => void;
}>();
